import { useEffect, useState } from 'react';
import Input from '@components/forms/Input';
import Select from '@components/forms/Select';
import { Option } from '@material-tailwind/react';
import { ReactComponent as SearchIcon } from '@assets/icons/search_icon.svg';
import { useAgreementStore } from '@stores';

const FilterBar = () => {
  const {
    query,
    setQuery,
    status,
    setStatus,
    whiteLabel,
    setWhiteLabel,
    whiteLabelOptions
  } = useAgreementStore();

  const [searchTerm, setSearchTerm] = useState(query);

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      setQuery(searchTerm);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchTerm, setQuery]);

  const statusOptions = [
    { value: 'ALL', label: 'All Status' },
    { value: 'In Life', label: 'In Life' },
    { value: 'Quoted', label: 'Quoted' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Cancelled', label: 'Cancelled' }
  ];

  return (
    <div className="flex flex-col md:flex-row gap-4 w-full mb-6">
      <div className="flex-1 max-w-md relative">
        <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-grey-400 z-10" />
        <Input
          placeholder="Search agreements..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pl-10"
        />
      </div>

      <div className="flex flex-col sm:flex-row gap-4">
        <Select
          value={status}
          onChange={(value) => setStatus(value || 'ALL')}
          className="w-full sm:w-48">
          {statusOptions.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>

        <Select
          value={whiteLabel}
          onChange={(value) => setWhiteLabel(value || 'ALL')}
          className="w-full sm:w-48">
          {(whiteLabelOptions || [{ value: 'ALL', label: 'All Brands' }])
            .filter((option) => option && option.value != null)
            .map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
        </Select>
      </div>
    </div>
  );
};

export default FilterBar;
